/** angular */
import { Component, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
/** end angular */

/**
 * Custom input based on Angular material, used to search,
 * This component's width is adaptive through its parent
 *
 * A part of the style is written here: /ds-style-themes.scss
 */
@Component({
  selector: 'ds-lib-search-bar',
  templateUrl: './ds-lib-search-bar.component.html',
  styleUrls: ['./ds-lib-search-bar.component.scss'],
})
export class DsLibSearchBarComponent {
  /**
   * The form control used to search
   */
  private _searchControl: FormControl;

  /**
   * Set searchControl.
   *
   * @param control FormControl
   */
  @Input() public set searchControl(control: FormControl) {
    this._searchControl = control;
  }

  /**
   * Get searchControl.
   *
   * @returns FormControl
   */
  public get searchControl(): FormControl {
    return this._searchControl;
  }

  /**
   * Enable or Disable the search control.
   *
   * @param value isEnabled state
   */
  @Input() public set isEnabled(value: boolean) {
    value ? this.searchControl.enable() : this.searchControl.disable();
  }

  /**
   * Placeholder displayed when the search is unfocused
   */
  @Input() public placeholder: string;

  /**
   * Emit to parent when the input loses focus
   */
  @Output() public blurEmitter = new EventEmitter();

  @ViewChild('searchInput') searchInput: ElementRef;

  /**
   * Instantiate Inputs with default values.
   */
  constructor() {
    this.searchControl = new FormControl('');
    this.placeholder = 'search';
  }

  /**
   * Emit to parent that the search lost focus.
   */
  public onBlur() {
    this.blurEmitter.emit();
  }

  /**
   * Emit to parent that the search focus.
   */
  public focus() {
    this.searchInput.nativeElement.focus();
  }
}
